import React, { useMemo } from "react";
import { css, Theme, useTheme } from "@emotion/react";

import useBreakpoint from "core/hooks/useBreakpoint";
import { isUp } from "theme/breakpoints";

import ItemQuantityText from "pages/Components/ProductPage/ItemQuantityText";
import QuantityPlusMinusButton from "core/Components/Buttons/QuantityButton/QuantityPlusMinusButton";

type Props = {
    quantity: number,
    maxQuantity: number,
    onPlusIconClick: (e: React.MouseEvent) => void,
    onMinusIconClick: (e: React.MouseEvent) => void,
    onCustomQuantity: (e: React.ChangeEvent<HTMLInputElement>) => void,
};

const ItemQuantityBox: React.FC<Props> = ({
    quantity,
    maxQuantity,
    onPlusIconClick,
    onMinusIconClick,
    onCustomQuantity,
}) => {
    const theme: Theme = useTheme();

    const { breakpoint } = useBreakpoint();
    const quantityText = useMemo(() => {
        switch (true) {
            case isUp(breakpoint, "sm"):
                return 'Quantity';
            default:
                return 'Qty';
        }
    }, [breakpoint]);

    const style = css`
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 61px;

        ${theme.breakpoints.only('xl')} {
            margin-top: 56px;
        }

        ${theme.breakpoints.only('lg')} {
            margin-top: 35px;
        }

        ${theme.breakpoints.only('md')} {
            margin-top: 46px;
        }

        ${theme.breakpoints.only('sm')} {
            margin-top: 33px;
        }
        
        ${theme.breakpoints.down('xs')} {
            margin-top: 41px;
        }
    `;

    const quantityButtonStyle = css`
        background-color: white;
    `;

    return (
        <div css={style}>
            <ItemQuantityText text={quantityText} />
            <QuantityPlusMinusButton
                css={quantityButtonStyle}
                quantity={quantity}
                maxQuantity={maxQuantity}
                onPlusIconClick={onPlusIconClick}
                onMinusIconClick={onMinusIconClick}
                onCustomQuantity={onCustomQuantity}
            />
        </div>
    );
};

export default ItemQuantityBox;